import React from "react";
import { COLORS } from "shared/consts";
import {IconProps} from './index.tsx';

export const Pesticide: React.FC<IconProps> = ({
                                               fill = COLORS.FG.SOFT,
                                               width = 24,
                                               height = 24,
                                               className,
                                           }) => {
    return (
        <svg className={className} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
             width={width} height={height} fill="none">
            <rect id="24 / Special / Pesticide Map" width={width} height={height} x="0.000000" y="0.000000"/>
            <path id="Union"
                  d="M6 4.5L12.5 4.5L12.5 3L6 3C4.34315 3 3 4.34315 3 6L3 18C3 19.6569 4.34315 21 6 21L18 21C19.6569 21 21 19.6569 21 18L21 6C21 4.34316 19.6569 3 18 3L18 4.5C18.8284 4.5 19.5 5.17158 19.5 6L19.5 18C19.5 18.1344 19.4824 18.2648 19.4492 18.3887L5.61133 4.55078C5.73525 4.51764 5.86563 4.5 6 4.5ZM15.9062 8.20703L16.0996 5.77734L16.0996 3L14.5 3L14.5 5.77734L14.6943 8.20703L15.9062 8.20703ZM4.5 6C4.5 5.86563 4.51764 5.73525 4.55078 5.61133L10.9395 12L4.55078 18.3887C4.51764 18.2648 4.5 18.1344 4.5 18L4.5 6ZM16.0996 11L14.5 11L14.5 9.40039L16.0996 9.40039L16.0996 11ZM6 19.5C5.86563 19.5 5.73525 19.4824 5.61133 19.4492L12 13.0605L18.3887 19.4492C18.2648 19.4824 18.1344 19.5 18 19.5L6 19.5Z"
                  fill={fill} fillRule="evenodd"/>
        </svg>
    );
};
